import { render, staticRenderFns } from "./School.vue?vue&type=template&id=49ce6130&scoped=true&"
import script from "./School.vue?vue&type=script&lang=js&"
export * from "./School.vue?vue&type=script&lang=js&"
import style0 from "./School.vue?vue&type=style&index=0&id=49ce6130&prod&lang=css&"
import style1 from "./School.vue?vue&type=style&index=1&id=49ce6130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ce6130",
  null
  
)

export default component.exports